<template>
  <v-footer dark padless v-if="getTheme.id === 'beneteau'">
    <v-card
      :class="['flex', isNavbar ? 'primary' : 'grey lighten-5']"
      flat
      tile
    >
      <v-card-text class="py-2 grey--text text-center">
        <a
          class="link--color"
          href="https://www.sentinelmarine.net/"
          target="_blank"
        >
          <v-img
            align="center"
            justify="center"
            contain
            :transition="false"
            :class="[
              isNavbar
                ? 'logo-powered-by-sentinel-isNavbar'
                : 'logo-powered-by-sentinel-notNavbar',
              'mx-auto',
            ]"
            :src="
              require(`@/assets/${this.$store.getters.getLogo.path}/logo-powered-by-sentinel.svg`)
            "
          />
        </a>
      </v-card-text>
    </v-card>
  </v-footer>
</template>
<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "PoweredBySentinel",
  props: {
    isNavbar: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["getTheme"]),
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";
.link--color {
  color: var(--primary);
}

primary {
  color: var(--primary);
}

grey {
  color: "grey lighten-5";
}

.logo-powered-by-sentinel-isNavbar {
  width: 120px;
  height: 120px;
  filter: saturate(100%) brightness(60%);
  transition: transform 0.3s;
  transition: 0.3s;
}
.logo-powered-by-sentinel-isNavbar:hover {
  filter: saturate(100%) brightness(100%);
  transform: translateY(-10px);
}

.logo-powered-by-sentinel-notNavbar {
  width: 120px;
  height: 120px;
  filter: saturate(100%) brightness(60%);
  transition: transform 0.3s;
  transition: 0.3s;
}
.logo-powered-by-sentinel-notNavbar:hover {
  filter: saturate(100%) brightness(0%);
  transform: translateY(-10px);
}
</style>
